<template>
    <textarea v-if="visible" :rows="initialRows" v-model="value" :class="[clazz, errorClass, 'textarea']" :style="style"
              :readonly="ro" ref="area_tag" v-bind="attrs"></textarea>
</template>

<script setup lang="ts">
import autosize from "autosize";
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed, nextTick, onMounted, ref} from "vue";
import type {TextArea} from "@t/fd/editor/TextArea";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const area = computed<TextArea>(() => props.part as TextArea);

const area_tag = ref(null);
const {visible, value, clazz, errorClass, style, ro, tabindexBinding} = useEditor(props);

const initialRows = computed(() => {
    if (typeof area.value.rows === "number") return area.value.rows;
    return area.value.autosize ? 1 : 2;
});

const attrs = computed(() => {
    const a: any = tabindexBinding();
    if (typeof area.value.placeholder === "string") a.placeholder = area.value.placeholder;
    if (typeof area.value.maxLength === "number") a.maxlength = area.value.maxLength;
	if (typeof area.value.autocomplete === "string") a.autocomplete = area.value.autocomplete;
	return a;
});

onMounted(() => {
    const ar: boolean = typeof area.value.autosize === "boolean" ? area.value.autosize : false;
    if (area_tag.value && ar) {
        nextTick(() => {
            if (area_tag.value) autosize(area_tag.value);
        });
    }
});
</script>

<style>
.fd-form textarea {
    outline: 0;
    border: none;
    padding: var(--input-v-padding) var(--input-h-padding);
    box-sizing: border-box;
    font-family: var(--font);
    font-size: var(--input-font-size, 14px);
    line-height: var(--input-height, 18px);
    resize: none;
}

.fd-form textarea:invalid,
.fd-form textarea.invalid {
    color: var(--input-error-fg);
    background-color: var(--input-error-bg);
}

.fd-form textarea.warn {
    color: var(--warn-fg);
    background-color: var(--warn-bg);
}

.fd-form textarea:disabled,
.fd-form textarea:read-only {
    color: var(--input-disabled-fg);
    background-color: var(--input-disabled-bg);
}

</style>
